<template>
	<div>
		<!--Charts-->
		<div class="row">
			<div class="col-12">
				<real-power-card title="REAL TIME POWER">
				</real-power-card>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { RealPowerCard } from "@/components/index";

export default {
	components: {
		RealPowerCard,
	},
	data() {
		return {
		};
	},
};
</script>
<style>
</style>
